import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/index/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      // redirect: '/login',
      redirect: '/home',
    },
    {
      path: '/login',
      name: '登录页',
      component: () =>
        import('@/page/login/index'),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },


    {
      path: '/home',
      component: Layout,
      redirect: '/home/index',
      children: [
        {
          path: 'index',
          name: '平台首页',
          component: () =>
            import('@/views/home/index')
        },
				{
				  path: 'api-apply',
				  name: '接口申请',
				  component: () =>
				    import('@/views/home/api-apply')
				},
			]
    },


    // {
    //   path: '/user',
    //   component: Layout,
    //   redirect: '/user/user_manage',
    //   children: [
    //     {
    //       path: 'user_manage',
    //       name: '商户列表',
    //       component: () =>
    //         import('@/views/user/user_manage')
    //     },
    //     {
    //       path: 'fund',
    //       name: '待审核',
    //       component: () =>
    //         import('@/views/user/fund_manage')
    //     },
    //     {
    //       path: 'index',
    //       name: '余量预警',
    //       component: () =>
    //         import('@/views/user/index')
    //     },
    //     {
    //       path: 'thoroughfare',
    //       name: '通道管理',
    //       component: () =>
    //         import('@/views/user/thoroughfare')
    //     },
    //   ]
    // },

    {
      path: '/api-manage',
      component: Layout,
      redirect: '/api-manage/api-desc',
      children: [
        {
          path: 'api-desc',
          name: '接口介绍',
          component: () => import('@/views/api-manage/api-desc'),
        },
        {
          path: 'api-doc',
          name: '接口文档',
          component: () => import('@/views/api-manage/api-doc'),
        },
        // {
        //   path: 'api-apply',
        //   name: '待审核通道',
        //   component: () => import('@/views/api-manage/api-apply'),
        // },
      ]
    },


    // {
    //   path: '/product',
    //   component: Layout,
    //   redirect: '/product/index',
    //   children: [
    //     {
    //       path: 'index',
    //       name: '数据分类',
    //       component: () =>
    //         import('@/views/product/index')
    //     },
    //     {
    //       path: 'template',
    //       name: '数据模板',
    //       component: () =>
    //         import('@/views/product/template')
    //     },
    //     {
    //       path: 'caozuo',
    //       name: '数据操作',
    //       component: () =>
    //         import('@/views/product/caozuo')
    //     }
    //   ]
    // },


    // {
    //   path: '/test',
    //   component: Layout,
    //   redirect: '/test/index',
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'IP黑名单',
    //       component: () =>
    //         import('@/views/test/index')
    //     },
    //     // {
    //     //   path: 'access',
    //     //   name: '单IP访问评率',
    //     //   component: () =>
    //     //     import('@/views/test/access')
    //     // }
    //   ]
    // },


    // {
    //   path: '/setweb',
    //   component: Layout,
    //   redirect: '/setweb/index',
    //   children: [
    //     {
    //       path: 'index',
    //       name: '轮播图',
    //       component: () =>
    //         import('@/views/setweb/index')
    //     },
    //     {
    //       path: 'announcement',
    //       name: '平台公告',
    //       component: () =>
    //         import('@/views/setweb/announcement')
    //     },
    //     // {
    //     //   path: 'apply',
    //     //   name: '申请页面',
    //     //   component: () =>
    //     //     import('@/views/setweb/apply')
    //     // }
    //   ]
    // },

    // {
    //   path: '/system',
    //   component: Layout,
    //   redirect: '/system/index',
    //   children: [
    //     {
    //       path: 'logdata',
    //       name: '日志列表',
    //       component: () =>
    //         import('@/views/system/logdata')
    //     },
    //     {
    //       path: 'monitor',
    //       name: '系统监控',
    //       component: () =>
    //         import('@/views/system/monitor')
    //     },
    //   ]
    // },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js